import request from '../request';

export const getLogsAudit = (filter) => request.get('audit', { params: { filter } }).then((res) => res);

export const getLogsAuditSummary = (filter) =>
  request.get('audit/summary', { params: { filter } }).then((res) => res);

export const getLogsAuditSkipAndLimit = (skip = 0, limit = 5, filter) =>
  request.get(`audit/skip/${skip}/limit/${limit}`, { params: { filter } }).then((res) => res);

export const getLogAuditById = (id) => request.get(`audit/${id}`).then((res) => res);
